import AdUtils from '@shared/utils/ads';
import DeviceConfig from '@devices/config';
import FastEvent from '../../classes/fastEvent';
import Pages from '@pages';
import Sections from '@shared/types/enums/sections';
import { fetchNextEpisode } from '../../../shared/store/thunks/player.thunk';
import { pushRoute } from '../../store/thunks/route.thunk';
import { setAds } from '@shared/store/slices/ads.slice';
import { store } from '../../store/store';
import { popRoute, updateParams } from '@shared/store/slices/router.slice';
import AnalyticsInstance from '@shared/utils/analytics';
import { OmnitrackPlaybackInteraction } from '@tvup/omnitrack-js';

function goToPlayer({
  asset,
  forceRestart,
  nextEpisode = false,
}: {
  asset: FastEvent;
  forceRestart?: boolean;
  nextEpisode?: boolean;
}) {
  if (asset?.dummy) return;

  // Update keep watching mark

  const { keepWatching, router } = store.getState();
  const keepWatchingAsset = keepWatching.data.find((item) => {
    return item.id === asset?.eventId;
  });
  if (
    keepWatchingAsset &&
    (asset.endBookmark ? keepWatchingAsset.mark < asset.endBookmark : true) &&
    !forceRestart
  ) {
    asset.keepWatchingMark = keepWatchingAsset.mark;
  } else {
    asset.keepWatchingMark = 0;
  }

  // Launch player

  if (asset.catchup && !DeviceConfig?.capabilities?.disableAds?.prerolls) {
    store.dispatch(
      setAds(AdUtils.getSource(Sections.CATCHUP, false, asset?.channel))
    );
  }
  AnalyticsInstance.setPlaybackInteraction(OmnitrackPlaybackInteraction.CLICK);
  // Only keep one player at the stack at most
  if (router.route.stack.includes(Pages.PLAYER)) {
    store.dispatch(popRoute());
    store.dispatch(updateParams({ content: asset }));
  } else {
    store.dispatch(
      pushRoute({
        route: { Page: Pages.PLAYER, push: !nextEpisode },
        params: {
          current: {
            content: asset,
          },
          push: !nextEpisode,
        },
      })
    );
  }

  // Fetch next episode

  store.dispatch(fetchNextEpisode(asset));
}

export default goToPlayer;
